import React from 'react';
import roles from 'helpers/roles';
import { withTranslation } from 'react-i18next';
import getReportFileName from 'helpers/getReportFileName';

import BaseBrandReport from './BaseBrandReport';
import MIME_TYPES from './constants/mimeTypes';

class BoxLabelsMini extends React.Component {
  render() {
    const { t } = this.props;
    const title = t('reports.reportBoxLabelsMini');
    return (
      <BaseBrandReport
        title={title}
        excelUrl="reports/bag-stickers-mini"
        mimeType={MIME_TYPES.xlsx}
        fileName={getReportFileName(title)}
        role={roles.ROLE_SHOW_REPORT_BAG_STICKERS_MINI}
        excelAvailable={true}
        previewXlsxAvailable={true}
        archiveReportNames={['BAG_STICKERS_MINI']}
        dateType="single"
        isSalesMarketLangViewEnabled={true}
      />
    );
  }
}

export default withTranslation()(BoxLabelsMini);
